import http from "./httpService";
import { getJwt } from "./authService";
import { healthInputsTypes } from "../pages/health-events";
const apiEndpoint = process.env.REACT_APP_API_URL + "/health-events";

http.setJwt(getJwt()!);

export const HealthEventsServie = async (params: healthInputsTypes) => {
  const { data } = await http.post(apiEndpoint, { ...params });
  return data;
};

export const updateHealthEventsServie = async (params: any, id: string) => {
  delete params._id;
  delete params.__v;
  const { data } = await http.put(apiEndpoint + `/${id}`, { ...params });
  return data;
};

export default HealthEventsServie;
